import { InteractionType } from '@azure/msal-browser';
import { type MsalAuthenticationResult, MsalAuthenticationTemplate } from '@azure/msal-react';
import { type PropsWithChildren } from 'react';

import { PageLoadingFullscreen } from '../../components/general/PageLoadingFullscreen';
import { loginRequest } from '../../utils';

const ErrorWrapper = (result: MsalAuthenticationResult) => {
  console.log('Authentifizierungsfehler', { result });
  throw new Error('Authentifizierungsfehler', { cause: result.error });
};

const Loading = () => <PageLoadingFullscreen msg="Du wirst eingeloggt..." />;

export const WithAuth = ({ children }: PropsWithChildren) => (
  <MsalAuthenticationTemplate
    authenticationRequest={loginRequest}
    errorComponent={ErrorWrapper}
    interactionType={InteractionType.Redirect}
    loadingComponent={Loading}
  >
    {children}
  </MsalAuthenticationTemplate>
);
